
import * as React from 'react';
import { CSSProperties } from 'react';
import { Icon, Avatar, Popconfirm } from 'antd';
import { Link } from 'react-router-dom';
import { UIBasic, IPropsBasic } from 'kts-scaffold-framework/modules';
import { connect, MyStore, reducers } from 'kts-platform-frame/redux';
import language from 'kts-platform-frame/entry/Language';
import ReduxState, { IUser } from 'kts-platform-frame/redux/ReduxState';
import { UserType } from 'kts-platform-frame/entry/constant';
import ModulesState from './Modules.State';
import ModulesAction from './Modules.Action';
import { AppKey } from 'kts-platform-frame/entry/constant';
import AppSdk from 'kts-platform-frame/appSdk';
import { OPEN_TYPE } from 'kts-platform-frame/appSdk/openApp';
import { IAppInfo } from 'kts-platform-frame/dataModel';
import { withRouter } from 'kts-platform-frame/routes';
import { history } from 'kts-platform-frame/routes';

const css = require('./index.scss');
const HeadPortrait = require('./IMG.HeadPortrait.jpeg');

/** Redux接口 */
interface IReduxStatePart {
    nickName?: string;
    email?: string;
    phone?: string;
    userType?: UserType;
    user?: IUser;
    currentcompanyId?: string;
    companyName?: string;
    menuAppList?: IAppInfo[];
}

/** Props接口 */
interface IProps extends IReduxStatePart, IPropsBasic {
}

/** 用户面板 */
@withRouter
@ModulesAction.uiconnect
@connect((state: ReduxState): IReduxStatePart => ({
    nickName: state.user.userInfo.nickName,
    email: state.user.userInfo.email,
    phone: state.user.userInfo.phone,
    companyName: state.user.userInfo.companyName,
    userType: state.user.userInfo.userType,
    menuAppList: state.system.menuAppList
}))
export default class UIUserPanel extends UIBasic<IProps, ModulesState> {

    state = {
        menuStyle: {} as CSSProperties,
        guideTipVisible: false,
    };

    constructor(props: IProps) {
        super(props, ModulesAction);
    }

    /** 用户类型名称 */
    private get nickNameName(): string {
        const userTypeString: string = language.userTypeToString.get(this.props.userType);
        return userTypeString || '未知';
    }

    componentDidMount() {
        this.setCollapsedStyle();
        this.showNewGuideVersion();
    }

    render() {
        const { companyName } = this.props;
        const nickName = this.props.nickName || this.props.email || this.props.phone;
        return (
            <div className={css.userPanel} style={this.collapsedStyle()} >
                <Avatar className={css.headPortrait} src={HeadPortrait} />
                {
                    this.modulesState.collapsed ||
                    <div>
                        <div className="clear" >
                            <div title={nickName} className={`${css.userPanelNickName} text-overflow`} >{nickName}</div>
                            <div title={this.nickNameName} className={`${css.userPanelNickNameName} text-overflow`} >{this.nickNameName}</div>
                        </div>
                        <p className={`${css.companyName} text-overflow`} title={companyName} >{companyName}</p>
                    </div>
                }
                <ul className={css.userPanelMenu} data-collapsed={this.modulesState.collapsed ? 1 : 0} >
                    <li><Link to="/workbench/platform/userCenter"><Icon type="userinfo-gerenxinxi" /></Link></li>
                    <li><a onClick={ModulesAction.unlogin} ><Icon type="exit" /></a></li>
                    {ModulesAction.isInstallApp(AppKey.切换公司) && <li><a onClick={this.onClickCompanySwitchHandler}><Icon type="weibiaoti-_fuzhi" /></a></li>}
                    <li>
                        <Popconfirm 
                            placement="rightBottom" 
                            title="点击体验新版"
                            onConfirm={this.onClickSwitchVersionHandler} 
                            onCancel={this.setSwitchVersion}
                            okText="立即体验" 
                            cancelText="取消" 
                            visible={this.state.guideTipVisible}
                            // defaultVisible={this.showNewGuideVersion()}
                        >
                            <a onClick={this.onClickSwitchVersionHandler}><Icon type="shuaxin" /></a>
                        </Popconfirm>
                    </li>
                </ul>
            </div>
        );
    }

    /** 点击了切换公司 */
    private onClickCompanySwitchHandler = () => {
        AppSdk.instance.openApp(this, {
            appKey: AppKey.切换公司,
            openType: OPEN_TYPE.右侧弹窗,
        });
    }

    /** 切换版本 */
    private onClickSwitchVersionHandler = () => {
        this.setSwitchVersion();
        MyStore.instance.dispatch(reducers.system.ActionTypes.setVersion, '0.3');
    }

    /** 设置宽度 */
    private setCollapsedStyle() {
        this.setState({
            menuStyle: {
                width: this.modulesState.collapsed ? 64 : 180,
            }
        });
    }

    /** 收着样式切换 */
    private collapsedStyle(): CSSProperties {
        return {
            ...this.state.menuStyle,
            width: this.modulesState.collapsed ? 64 : 180,
            position: 'fixed',
            bottom: 0,
        };
    }
    /** 从session中读取是否展示新版本提示 */
    private showNewGuideVersion = () => {
        const guideVersionUser = JSON.parse(sessionStorage.getItem("guideVersionUser"));
        const { user } = MyStore.instance.getState();  
        this.setState({
            guideTipVisible: guideVersionUser && guideVersionUser[user.userInfo.gUserId] ? false : true
        });
        // return guideVersionUser && guideVersionUser[user.userInfo.gUserId] ? false : true;
    }
    /** 将是否显示新手引导存入session */
    private setSwitchVersion = () => {
        const { user } = MyStore.instance.getState();  
        const guideVersionUser = {};
        guideVersionUser[user.userInfo.gUserId] = true;
        sessionStorage.setItem("guideVersionUser", JSON.stringify(guideVersionUser));
        this.setState({
            guideTipVisible: false
        });
    }
}



// WEBPACK FOOTER //
// ./src/display/modules/Home/Workbench/UI.UserPanel.tsx